<template>
  <span>
    <b-button
      type="button"
      variant="danger"
      class="mt-3"
      @click="onShowModal()"
      :disabled="isDisabled"
    >{{ 'delete' | translate('global') }}</b-button>
    <Modal ref="delete-invoice" @onClose="closeModal" :values="modalValues">
      <template slot="footer">
        <b-button
          variant="danger"
          data-dismiss="modal"
          :disabled="spinners.isDeleting"
          @click="onDelete()"
        >
          <b-spinner v-if="spinners.isDeleting" type="grow" small />
          {{ 'delete' | translate('global') }}
        </b-button>
        <b-button
          variant="secondary"
          @click="closeModal()"
          class="ml-2"
        >{{ 'cancel' | translate('global') }}</b-button>
      </template>
    </Modal>
  </span>
</template>
<script>
import statuses from "@/store/statuses";
import Modal from "@/views/sharedComponents/Modal";
import { mapGetters, mapActions } from "vuex";
import VuexTypes from "@/store/types/index";

const InvoicesTypes = VuexTypes.invoices;
export default {
  mounted() {},
  data() {
    return {
      spinners: {
        isDeleting: false
      },
      isDisabled: true,
      modalValues: {
        id: "delete-invoice",
        title: this.$t("delete_invoice", "global"),
        body: this.$t("delete_invoice_confirm_text", "global")
      }
    };
  },
  components: { Modal },
  computed: {
    ...mapGetters("Invoices", ["invoiceUpdateData", "invoiceDelete"])
  },
  watch: {
    invoiceDelete: {
      handler: function() {
        this.spinners.isDeleting = false;
        if (this.invoiceDelete.status === statuses.LOADED) {
          this.closeModal();
          this.$router.push({ name: "Invoices", params: { page: 1 } });
        }
      },
      deep: true
    },
    invoiceUpdateData: {
      immediate: true,
      handler: function() {
        this.spinners.isDeleting = false;
        if (this.invoiceUpdateData.status === statuses.LOADED) {
          const actions = this.invoiceUpdateData.data["invoice"]["actions"]
            ? this.invoiceUpdateData.data["invoice"]["actions"]
            : {};
          this.isDisabled = !actions["delete"];
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("Invoices", [InvoicesTypes.INVOICE_DELETE]),
    onShowModal(data) {
      this.$refs["delete-invoice"].show();
      this.deleteData = data;
    },
    closeModal() {
      this.$refs["delete-invoice"].hide();
    },
    onDelete() {
      this.spinners.isDeleting = true;
      this.INVOICE_DELETE(this.$route.params.id);
    }
  }
};
</script>
<style scoped>
</style>
